import React, {Component} from 'react';

import DetailHeader from './DetailHeader'
import Footer from './Footer'
class BaseDetail extends Component {

    componentWillMount() {

    }

    render() {
        return (
            <div>

                {/*<div className="page-loader startLoad">
                    <div className="loader startLoad"></div>
                </div>*/}

                <div id="wrap">
                    <DetailHeader/>

                    { this.props.children }

                    <Footer />
                    <div id="mask"></div>
                </div>
            </div>
        );
    }

}

export default BaseDetail
